import moment from 'moment/min/moment-with-locales';
window.moment = moment;
